/* eslint-disable @typescript-eslint/no-var-requires */
const res = require('res');

/**
 * Returns approximate screen width in inches
 */
export function getScreenWidth() {
  return (window.devicePixelRatio * window.innerWidth) / res.dpi();
}
